import useSWR from 'swr';
import { IExplorer } from '@/types/explorer';
import { getMainExplorerData } from '@/api/explorer';
import { SWRCacheKeys } from '@/constants/cache';

const REFRESH_INTERVAL = 180000; // 3 minutes

interface IUseExplorerDataOptions {
  processRegions?: boolean;
}

export default function useExplorerData(
  { processRegions }: IUseExplorerDataOptions = { processRegions: false },
) {
  const cacheKey = processRegions
    ? SWRCacheKeys.ExplorerWithRegions
    : SWRCacheKeys.Explorer;

  const { data, error } = useSWR<IExplorer | undefined>(
    cacheKey,
    () => getMainExplorerData(processRegions),
    {
      refreshInterval: REFRESH_INTERVAL,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
    },
  );

  return {
    data,
    isLoading: !error && !data,
    isError: error,
  };
}
